import { Text } from '@taxdown/piccolo-web';
import useTranslation from 'Hooks/useTranslation';
import { CustomInputProps } from './types';
import * as Styled from './styles';

const CustomInput = ({
  label,
  value,
  onClick,
  textAction,
  isUpdatable,
}: CustomInputProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Styled.InputContainer direction="column" gap="dimension_08">
      <Text type="paragraphs" size="S_L_S" color="dark">
        {label}
      </Text>
      <Styled.Input>
        <Text type="paragraphs" size="S_S_S" color="dark">
          {value}
        </Text>
        {isUpdatable && <Styled.TextAction onClick={onClick}>{t(textAction)}</Styled.TextAction>}
      </Styled.Input>
    </Styled.InputContainer>
  );
};

CustomInput.defaultProps = {
  textAction: 'common:Input.change',
};

export default CustomInput;
